import React, { useEffect, useRef, useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ToastManager from '../../default/popup/alert/apiNotification';
import { useSelector } from 'react-redux';

const ExportLeadPopup = ({ openModal, setOpen}) => {
    const [title, setTitle] = useState('');
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false); 
    const closeModal = () => setOpen(false);
    const inputRef = useRef(null);
    const { auth } = useSelector((state) => state);
    const { user} = auth;
    const { U_Email} = user;
  
    useEffect(() => {
        if (openModal) {

        setTitle('Cardiast leads');
        setError('')
          const timer = setTimeout(() => {
            inputRef.current?.focus();
          }, 100); 
    
          return () => clearTimeout(timer);
        }
      }, [openModal]);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const toastId = ToastManager.showLoading('Submitting...');
        try {
            setIsProcessing(true);
            const response = await axios.post('/prospector/export', {
              title: title
            });
            if (response.status >= 200 && response.status < 300) {
                ToastManager.showSuccess(toastId, response.data.message || 'Your request has been received');
            }
            setIsProcessing(false);
            setTitle('');
            closeModal();
        } catch (err) {
            setIsProcessing(false);
            let errorMsg = err.response?.data ? Object.values(err.response.data).join(', ') : 'Failed to submit your request!';
            setError(errorMsg);
            ToastManager.showError(toastId, errorMsg || 'Failed to add business.');
        }
    };
    

    return (
        <div>
            <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
                <div className="modal">
                    <div className="modal-header">
                        <h3>Export prospects</h3>
                        <Link className="close" onClick={closeModal}>
                          &times;
                        </Link>
                    </div>
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group form-export-content">
                                <input
                                    name="add_new_category"
                                    placeholder="Export Title"
                                    value={title}
                                    ref={inputRef}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                                <p>You will received the exported CSV file in your email at <strong>{U_Email? U_Email : 'Email not found!'}</strong></p>
                            </div>
                            {error && <p className="error">{error}</p>}
                            
                            <div className="text-right">
                                 <button type="submit" className="btn btn-submit" disabled={isProcessing}>
                                    {isProcessing ? 'Processing...' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default ExportLeadPopup;

// import Popup from 'reactjs-popup';

// const ExportLeadPopup = ({openModal, setOpen}) => {
//   const closeModal = () => setOpen(false);
//   return (
//     <div>
//       <Popup open={openModal} closeOnDocumentClick onClose={closeModal}>
//         <div className="modal">
//             <div className="modal-header">
//                 <h3>Export prospects</h3>
//             </div>
//           <div className="modal-content">
//             <div className="modal-form-content">
//                 <p>You will received the exported CSV file in your email at</p>
//                 <p>info@mail.com</p>
//             </div>
//           <form>
//             <div className="form-group">
//                 <label>Title</label>
//                 <input name="add_new_category" placeholder="Cardiast leads"/>
//             </div>
//             <div className="text-right">
//                 <button type="submit" className="btn btn-submit">Submit</button>
//             </div>
//           </form>
//           </div>
//         </div>
//       </Popup>
//     </div>
//   );
// };
// export default ExportLeadPopup;